




import { Component, Vue } from 'vue-property-decorator'
import 'semantic-ui-css/components/loader.min.css'

const statuses = [
  'Reticulating splines', 'Obtaining whisky', 'Thanos did nothing wrong',
  'Loading verticies', 'Scratching chinchillas', 'Lying about loading',
  'Patting Bel-chan', 'Writing spaghetti', 'DRYing the code',
  'The Empire did nothing wrong', 'Just Monika', 'Eating cake',
  'You do not recognize the bodies in the water', 'Daydreaming'
]

@Component
export default class Loader extends Vue {
  text = statuses[Math.floor(Math.random() * statuses.length)]
}
